export class ApiError extends Error {
  status: number;

  statusText: string;

  errorType: string | undefined;

  errorMessage: string | string[] | undefined;

  name = 'ApiError';

  constructor({
    status,
    statusText,
    errorType,
    errorMessage,
  }: {
    status: number;
    statusText: string;
    errorType?: string;
    errorMessage?: string | string[];
  }) {
    super();

    this.name = `${this.name}: ${errorType}`;
    this.status = status;
    this.statusText = statusText;
    this.errorType = errorType;
    this.errorMessage = errorMessage;
  }
}
